module.exports = __webpack_public_path__ + "img/xxkw_1-1.dbc3b3c2.jpg";